export default {
	Active: "Active",
	"Add credentials": "Add credentials",
	"Are you sure to delete credentials?": "Are you sure to delete credentials?",
	"Add new user": "Add new user",
	"Are you sure to delete this user?": "Are you sure to delete this user?",
	Audit: "Audit",
	Avatar: "Avatar",
	Cancel: "Cancel",
	"changes by": "changes by",
	"changes to": "changes to",
	Color: "Color",
	Credentials: "Credentials",
	Delete: "Delete",
	Deleted: "Deleted",
	"Delete credentials": "Delete credentials",
	Details: "Details",
	Done: "Done",
	"Enter password": "Enter password",
	"Enter user name": "Enter user name",
	"Error: no email": "Error: no email",
	"Full Name": "Full Name",
	General: "General",
	"Generate password": "Generate password",
	Description: "Description",
	Email: "Email",
	"Last visited": "Last visited",
	logins: "logins",
	Members: "Members",
	"Members assigned": "Members assigned",
	Modify: "Modify",
	Name: "Name",
	New: "New",
	"New password": "New password",
	"Not active": "Not active",
	"No members": "No members assigned",
	"No rules": "No rules assigned",
	Operation: "Operation",
	"Please submit an email first!": "Please submit an email first!",
	Registered: "Registered",
	"Reset password": "Reset password",
	Rules: "Rules",
	"Rules assigned": "Rules assigned",
	"Rule Matrix": "Rule Matrix",
	Save: "Save",
	Search: "Search",
	Status: "Status",
	Target: "Target",
	Unknown: "Unknown",
	"Unknown user": "Unknown user",
	"Upload new photo": "Upload new photo",
	"User Manager": "User Manager",
	Users: "Users",
	When: "When",
	Who: "Who",

	// used if Roles feature enabled
	"Add new role": "Add new role",
	"All assignments": "All assignments",
	"Are you sure to delete this role ?": "Are you sure to delete this role?",
	"Assigned directly": "Assigned directly",
	"Enter role name": "Enter role name",
	"No roles": "No roles assigned",
	Role: "Role",
	Roles: "Roles",
	"Roles assigned": "Roles assigned",
	"Role Matrix": "Role Matrix",
};
